var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("header"),_c('div',{staticClass:"page bt-container pb-3 pt-3 pl-0 pr-0"},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }